import { ProtectedRoute } from "@app/protected-route";
import { useGetModelList } from "@entities/model/model";
import { OcrGroupSettings } from "@pages/ocr-group-settings/ocr-group-settings";
import { createFileRoute, Navigate } from "@tanstack/react-router";

interface SearchParams {
	groupId: string;
	ocrFileId: string;
	editId?: string;
	drawerState?: "add" | "edit";
	groupName?: string;
}

export const Route = createFileRoute("/_layout/settings/ocr/$ocrId/group")({
	component: RouteComponent,
	validateSearch: (search: Record<string, unknown>): SearchParams => ({
		groupId: typeof search.groupId === "string" ? search.groupId : "",
		ocrFileId: typeof search.ocrFileId === "string" ? search.ocrFileId : "",
		editId: typeof search.editId === "string" ? search.editId : "",
		drawerState:
			search.drawerState === "add" || search.drawerState === "edit"
				? search.drawerState
				: undefined,
		groupName:
			typeof search.groupName === "string" ? search.groupName : undefined,
	}),
});

function RouteComponent() {
	const { models } = useGetModelList();
	const { ocrId } = Route.useParams();
	const { groupId, drawerState, editId, groupName, ocrFileId } =
		Route.useSearch();
	const navigate = Route.useNavigate();
	if ((models?.models?.length ?? 0) === 0) {
		return (
			<Navigate
				search={{
					search: "",
					startDate: "",
					endDate: "",
					page: 1,
					filterStatus: "",
					filters: {},
					tab: "single",
				}}
				to="/applications"
			/>
		);
	}
	return (
		<ProtectedRoute requiredPermissions={["root", "ocr_settings"]}>
			<OcrGroupSettings
				ocrId={ocrId}
				ocrFileId={ocrFileId}
				groupId={groupId}
				drawerState={drawerState}
				navigate={navigate}
				editId={editId ?? ""}
				groupName={groupName ?? ""}
			/>
		</ProtectedRoute>
	);
}
